(function () {
  'use strict';

  angular
    .module('core-ce.constants', [])
    .constant('maxChar', '\u4000');
}());
